import api from './api';

export interface Tenant {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  address: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface TenantCreate {
  name: string;
  slug: string;
  description?: string;
  contact_email?: string;
  contact_phone?: string;
  address?: string;
}

export const tenantService = {
  async getTenants(): Promise<Tenant[]> {
    const response = await api.get('/tenants/');
    return response.data;
  },

  async getMyTenant(): Promise<Tenant> {
    const response = await api.get('/tenants/my-tenant');
    return response.data;
  },

  async getTenant(tenantId: number): Promise<Tenant> {
    const response = await api.get(`/tenants/${tenantId}`);
    return response.data;
  },

  async createTenant(tenantData: TenantCreate): Promise<Tenant> {
    const response = await api.post('/tenants/', tenantData);
    return response.data;
  },

  async updateTenant(tenantId: number, tenantData: Partial<TenantCreate>): Promise<Tenant> {
    const response = await api.put(`/tenants/${tenantId}`, tenantData);
    return response.data;
  },

  async deleteTenant(tenantId: number): Promise<void> {
    await api.delete(`/tenants/${tenantId}`);
  },
};